export interface OrganizationInfo {
  name: string;
  logo?: string;
  url?: string;
  description?: string;
  address?: {
    streetAddress?: string;
    addressLocality?: string;
    addressRegion?: string;
    postalCode?: string;
    addressCountry?: string;
  };
  contactPoint?: {
    telephone?: string;
    email?: string;
    contactType?: string;
  };
  sameAs?: string[];
}

/**
 * Generate Organization schema
 * @param info - Organization information
 * @returns Schema.org Organization object
 */
export const generateOrganizationSchema = (info: OrganizationInfo) => {
  const schema: Record<string, any> = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: info.name,
  };

  if (info.url) {
    schema.url = info.url;
  }

  if (info.logo) {
    schema.logo = {
      "@type": "ImageObject",
      url: info.logo,
    };
  }

  if (info.description) {
    schema.description = info.description;
  }

  if (info.address) {
    schema.address = {
      "@type": "PostalAddress",
      ...info.address,
    };
  }

  if (info.contactPoint) {
    schema.contactPoint = {
      "@type": "ContactPoint",
      ...info.contactPoint,
    };
  }

  if (info.sameAs && info.sameAs.length > 0) {
    schema.sameAs = info.sameAs;
  }

  return schema;
};
